var React = require('react');

function Stroke3Blue (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#2E56B4","strokeWidth":"13","d":"M1484 9s-262-19-404 68c-46 29-100 74-160 120a805 805 0 0 1-319 166C397 404 190 235-36 248"}));
}

Stroke3Blue.defaultProps = {"viewBox":"0 0 1440 376"};

module.exports = Stroke3Blue;

Stroke3Blue.default = Stroke3Blue;
